import { seriesChart, groupChart } from './helper/helperHighcharts'

export const ChartOptions = ({ state, widget }) => {
    const { group, events, attr, select = [] } = state || {}
    const { jsonConfig } = widget || state || {}
    const { legendEnabled, legendRight } = jsonConfig || {}
    const categories = groupChart(events, group)

    return {
        chart: {
            type: 'bar'
        },
        plotOptions: {
            bar: {
                pointPadding: 0,
                borderWidth: 2,
                groupPadding: 0,
                shadow: false
            },
            series: {
                dataLabels: {
                    stacking: 'normal',
                    enabled: false,
                    y: 0,
                    showInLegend: 'false'
                }
            }
        },
        title: {
            text: ''
        },
        legend: {
            enabled: legendEnabled,
            layout: legendRight ? 'vertical' : 'horizontal',
            align: legendRight ? 'right' : 'center',
            bubbleLegend: { enabled: true, borderWidth: 2 },
            verticalAlign: legendRight ? 'middle' : 'bottom'
        },
        tooltip: {
            shared: true,
            format: 'series'
            // formatter: function() {
            //     return `${this.points[0].series.name} - ${this.points[0].x} <br/>
            // <strong>  ${this.points[1].point.description} </strong> / <strong> ${Highcharts.numberFormat(
            //         this.points[0].y,
            //         2,
            //         '.'
            //     )} % </strong>`
            // }
        },
        xAxis: {
            categories: categories,
            id: 'categories',
            labels: {
                rotation: -45
            },
            title: {
                text: 'Temperature (°c)',
                style: {
                    color: '#606A80',
                    fontSize: 12,
                    lineHeight: 16,
                    fontFamily: 'Source Sans Pro'
                }
            },
            alignTicks: false
        },
        yAxis: {
            title: {
                text: ''
            }
        },
        series: [
            {
                //TODO: COLOR DONT WORK
                name: group[0],
                color: events?.[0]?.__color || '#129a96',
                data: seriesChart(attr, events, select, group, '#129a96'),
                animation: false,
                type: 'bar',
                dataLabels: {
                    formatter: function() {
                        return this.point.value
                    }
                }
            }
        ]
    }
}
